const boxShadow: IBoxShadow = {
  card: '0px 0px 16px #0000000B',
  input: '0px 0px 16px rgba(0, 0, 0, 0.12)'
}

export default boxShadow
